import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { updateAppVersion, addAppVersion } from "../../actions";
import { createDiscount, updateDiscount } from "../../actions/discount";
import {  validateDiscount, validateDiscountOnChange, validateDiscountSubmit } from "../../validators";

export const useAddUpdateDiscountHook = ({
   getDiscountList = () => { },
   deleteDiscountEditData = {},
   showAddDiscountModal = false,
   isEdit = false,
   toggleAddDiscountModal = () => { }
}) => {
   const initialDiscountData = {
      title: "",
      description: "",
      discount: "",
      is_percentage: "",
      max_discount: "",
      status: ""
   }
   const [discountData, setDiscountData] = useState(deleteDiscountEditData || initialDiscountData)
   const [isLoading, setIsLoading] = useState(false);
   const [errorMessages, setErrorMessages] = useState({});

   useEffect(() => {
      if (isEdit) {
         setDiscountData(deleteDiscountEditData)
      } else {
         setDiscountData(initialDiscountData)
      }
      setErrorMessages({})
   }, [showAddDiscountModal])


   const handleInputChange = (event) => {
      const { name, value } = event.target
      const errors = validateDiscountOnChange(name, value, errorMessages)
      setErrorMessages(errors)
      setDiscountData({
         ...discountData,
         [name]: value
      })
   }


   const handleCheckboxChange = (value, name) => {
      const errors = validateDiscountOnChange(name, value, errorMessages)
      setErrorMessages({ ...errors })
      setDiscountData({
         ...discountData,
         [name]: value
      })
   }

   const handleSwitchChange = (selectedValue, name) => {
      const errors = validateDiscountOnChange(name, selectedValue, errorMessages)
      setErrorMessages({ ...errors })
      setDiscountData({
         ...discountData,
         [name]: selectedValue
      })
   }

   const handleDiscountSubmit = async () => {
      try {
         const errors = validateDiscountSubmit(discountData)
         setErrorMessages(errors)
         if (Object.keys(errors).length > 0) {
            return;
         }

         setIsLoading(true)

         let appVersionRes
         if (discountData.id) {
            appVersionRes = await updateDiscount(discountData.id, discountData)
         } else {
            appVersionRes = await createDiscount(discountData)
         }
         toggleAddDiscountModal()
         setErrorMessages({});
         getDiscountList()
         setDiscountData(initialDiscountData)
         toast.success(appVersionRes.ResponseText)
      } catch (error) {
         console.log({
            error
         });
         toast.error("Something went wrong")
      } finally {
         setIsLoading(false)
      }
   }

   return {
      discountData,
      isLoading,
      errorMessages,
      handleInputChange,
      handleSwitchChange,
      handleDiscountSubmit,
      setDiscountData,
      setErrorMessages,
      setDiscountData,
      handleCheckboxChange
   }
}